/* Знак заказа над меню для кадра движка (engine-kit, план движков §5.5): то же, что OrderTail.tsx:208-226 у native-хвоста, но «показан» —
   это активность кадра (у активного кадра с заказом страница заказа на экране, у спрятанного — нет). Публикуется после фиксации рендера,
   как эффект OrderTail: хозяин (EngineFrame) рендерится на каждый вид сервиса заказа (useOrderService), поэтому снимок читается из сервиса.
   Снятие кадра или его уход в тень — shown:false; после order-clear своего заказа («Изменить», «Попробовать ещё раз») о нём больше не
   публикуется ничего. Знак страницы шаблона (ui.job) в серверном режиме снят (server-ui), поэтому знак один.
   Вид знака — постоянный или по снимку сервиса (разрешитель экрана, engine-host.ts); null — знака нет (инструменты «Текста» без хвоста). */
import { useEffect, useRef } from 'react';
import { publishStudioOrder, type StudioOrderSnapshot } from '../studio-job-bridge';
import type { OrderService, OrderSnapshot } from './order-service';

const same = (a: StudioOrderSnapshot | null, b: StudioOrderSnapshot) =>
  !!a && a.owner === b.owner && a.appId === b.appId && a.orderId === b.orderId && a.status === b.status && a.kind === b.kind && a.shown === b.shown;

type BadgeKind = StudioOrderSnapshot['kind'];

export function useOrderBadge(svc: OrderService, kind: BadgeKind | ((s: OrderSnapshot) => BadgeKind | null) | null | undefined, active: boolean): void {
  const latest = useRef<StudioOrderSnapshot | null>(null);
  const cleared = useRef<Set<number>>(new Set());
  useEffect(() => {
    const s = svc.get(),
      orderId = svc.derive(s).orderId,
      resolved = typeof kind === 'function' ? kind(s) : kind;
    const owner = s.intent?.owner,
      appId = s.form?.app_id ?? s.intent?.body?.app_id,
      status = s.order?.status;
    if (!resolved || !owner || !appId || !orderId || !status || cleared.current.has(orderId)) {
      latest.current = null;
      return;
    }
    const next: StudioOrderSnapshot = { owner, appId, orderId, status, kind: resolved, shown: active };
    if (same(latest.current, next)) return;
    latest.current = next;
    publishStudioOrder(next);
  });
  useEffect(() => {
    const clear = (event: Event) => {
      const id = (event as CustomEvent<{ id?: unknown }>).detail?.id;
      if (typeof id !== 'number') return;
      cleared.current.add(id);
      if (latest.current?.orderId === id) latest.current = null;
    };
    document.addEventListener('steos:studio:order-clear', clear);
    return () => {
      document.removeEventListener('steos:studio:order-clear', clear);
      const last = latest.current;
      if (!last?.shown) return;
      latest.current = { ...last, shown: false };
      publishStudioOrder(latest.current);
    };
  }, []);
}
